export default "__VITE_ASSET__Xi6vw97e__"